(function (Drupal, once) {
  'use strict';

  // Create or extend shared namespace
  window.McmnExperience = window.McmnExperience || {};
  const Mcmn = window.McmnExperience;

  /**
   * Initialize Chapter 1 (Tree) interactions
   */
  function initChapter1(svgContainer, svg, chapterState, sectionType) {
    const basket = svg.querySelector('#basket-of-ornaments');
    const lightSwitch = svg.querySelector('#light-switch');
    const lights = svg.querySelector('#lights');
    const treePaths = svg.querySelector('#tree-paths');
    
    if (!basket || !lightSwitch || !lights || !treePaths) {
      return;
    }

    // Hide all hotspots immediately
    const decorateHotspot = svg.querySelector('#decorate-hotspot');
    const lightsHotspot = svg.querySelector('#lights-hotspot');
    if (decorateHotspot) {
      decorateHotspot.style.visibility = 'hidden';
      decorateHotspot.style.display = 'none';
      decorateHotspot.style.opacity = '0';
      decorateHotspot.style.pointerEvents = 'none';
    }
    if (lightsHotspot) {
      lightsHotspot.style.visibility = 'hidden';
      lightsHotspot.style.display = 'none';
      lightsHotspot.style.opacity = '0';
      lightsHotspot.style.pointerEvents = 'none';
    }

    // Ensure interactive elements are clickable and above content
    if (basket) {
      basket.style.pointerEvents = 'auto';
      basket.style.cursor = 'pointer';
      // Make sure all children also have pointer events
      const basketChildren = basket.querySelectorAll('*');
      basketChildren.forEach(child => {
        child.style.pointerEvents = 'auto';
      });
    }
    if (lightSwitch) {
      lightSwitch.style.pointerEvents = 'auto';
      lightSwitch.style.cursor = 'pointer';
    }

    // NOTE: Ornament restoration is now handled INSIDE initOrnamentDragDrop
    // where we have access to setupOrnamentInteract and proper SVG.js initialization
    
    // Restore lights state - CSS handles initial hiding
    const lightsOn = chapterState.lightsOn || false;
    if (lightsOn) {
      lights.style.visibility = 'visible';
      lights.style.opacity = '1';
    }
    // If lights are off, CSS handles the hiding
    
    // Hide decorate hotspot and message if ornaments were already placed (restored state)
    // COMMENTED OUT: Keep hotspots visible even after interaction
    // if (placedOrnaments.size > 0) {
    //   const decorateHotspot = svg.querySelector('#decorate-hotspot');
    //   const decorateTheTree = svg.querySelector('#decorate-the-tree');
    //   
    //   if (decorateHotspot) {
    //     decorateHotspot.style.visibility = 'hidden';
    //     decorateHotspot.style.display = 'none';
    //     decorateHotspot.style.opacity = '0';
    //   }
    //   
    //   if (decorateTheTree) {
    //     decorateTheTree.style.visibility = 'hidden';
    //     decorateTheTree.style.display = 'none';
    //     decorateTheTree.style.opacity = '0';
    //   }
    // }

    // Initialize light switch toggle with saved state
    initLightSwitch(svg, lightSwitch, lights, chapterState, sectionType);

    // Initialize ornament drag and drop with saved state
    initOrnamentDragDrop(svgContainer, svg, basket, treePaths, chapterState, sectionType);
  }

  /**
   * Initialize light switch toggle
   */
  function initLightSwitch(svg, lightSwitch, lights, chapterState, sectionType) {
    // Get message element (hotspot is hidden)
    const turnOnTheLights = svg.querySelector('#turn-on-the-lights');
    
    // Restore saved state
    let lightsOn = chapterState.lightsOn || false;

    // Make light switch clickable
    lightSwitch.style.cursor = 'pointer';
    
    // Function to toggle lights (extracted for reuse)
    const toggleLights = function(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      lightsOn = !lightsOn;

      // Save state
      chapterState.lightsOn = lightsOn;
      if (Mcmn.saveChapterState) {
        Mcmn.saveChapterState(sectionType, chapterState);
      }

      if (lightsOn) {
        // Mark lights hotspot as complete
        if (Mcmn.CookieManager && Mcmn.CookieManager.markHotspotComplete) {
          Mcmn.CookieManager.markHotspotComplete(sectionType, 'lights-hotspot');
          // Check completion after marking hotspot
          if (Mcmn.checkCompletion) {
            const viewedSections = new Set(Mcmn.CookieManager.getViewedSections());
            Mcmn.checkCompletion(viewedSections);
          }
        }
        lights.style.visibility = 'visible';
        gsap.to(lights, {
          opacity: 1,
          duration: 0.5,
          ease: 'power2.out'
        });
        
        // Hide the lights hotspot and message when lights turn on
        // COMMENTED OUT: Keep hotspots visible even after interaction
        // if (lightsHotspot) {
        //   gsap.to(lightsHotspot, {
        //     opacity: 0,
        //     duration: 0.5,
        //     ease: 'power2.out',
        //     onComplete: function() {
        //       lightsHotspot.style.visibility = 'hidden';
        //       lightsHotspot.style.display = 'none';
        //     }
        //   });
        // }
        // 
        // if (turnOnTheLights) {
        //   gsap.to(turnOnTheLights, {
        //     opacity: 0,
        //     duration: 0.5,
        //     ease: 'power2.out',
        //     onComplete: function() {
        //       turnOnTheLights.style.visibility = 'hidden';
        //       turnOnTheLights.style.display = 'none';
        //     }
        //   });
        // }
      } else {
        gsap.to(lights, {
          opacity: 0,
          duration: 0.5,
          ease: 'power2.in',
          onComplete: function() {
            lights.style.visibility = 'hidden';
          }
        });
      }
    };
    
    // Make message clickable to trigger light switch (hotspot is hidden)
    if (turnOnTheLights && !lightsOn) {
      turnOnTheLights.style.cursor = 'pointer';
      turnOnTheLights.style.pointerEvents = 'auto';
      turnOnTheLights.addEventListener('click', toggleLights);
      turnOnTheLights.addEventListener('touchend', function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleLights(e);
      }, { passive: false });
    }

    lightSwitch.addEventListener('click', toggleLights);
    lightSwitch.addEventListener('touchend', function(e) {
      e.preventDefault();
      e.stopPropagation();
      toggleLights(e);
    }, { passive: false });
  }

  /**
   * Initialize ornament drag and drop using SVG.js
   */
  function initOrnamentDragDrop(svgContainer, svg, basket, treePaths, chapterState, sectionType) {
    // Get message element (hotspot is hidden)
    const decorateTheTree = svg.querySelector('#decorate-the-tree');
    
    // Initialize SVG.js
    const svgJs = Mcmn.initSvgJs ? Mcmn.initSvgJs(svg) : null;
    if (!svgJs) {
      return;
    }
    
    // FIRST: Restore placed ornaments from saved state
    // This must happen BEFORE setting up the drag/drop system
    // so that setupOrnamentInteract is properly applied to restored ornaments
    const savedPlacedOrnaments = chapterState.placedOrnaments || new Set();
    const savedOrnamentPositions = chapterState.ornamentPositions || {};
    
    
    // Restore ornaments and their clones
    for (let i = 1; i <= 9; i++) {
      if (savedPlacedOrnaments.has(i) && savedOrnamentPositions[i]) {
        const positions = savedOrnamentPositions[i];
        
        // Check if it's new format (multiple instances with keys) or old format (direct x,y)
        if (typeof positions === 'object' && !positions.x) {
          // New format - multiple cloned instances
          Object.keys(positions).forEach(instanceKey => {
            const pos = positions[instanceKey];
            if (pos && pos.x !== undefined && pos.y !== undefined) {
              // CRITICAL: Check if this clone already exists to avoid duplicates
              let existingClone = svg.querySelector('#' + instanceKey);
              if (existingClone) {
                if (existingClone.parentNode) {
                  existingClone.parentNode.removeChild(existingClone);
                }
              }
              
              const originalOrnament = svg.querySelector('#ornament-' + i);
              if (originalOrnament) {
                // Clone the ornament
                const clonedOrnament = originalOrnament.cloneNode(true);
                clonedOrnament.id = instanceKey;
                clonedOrnament.style.visibility = 'visible';
                clonedOrnament.style.opacity = '1';
                
                // Add to SVG
                svg.appendChild(clonedOrnament);
                
                // Position using SVG.js
                const clonedJs = SVG.adopt(clonedOrnament);
                if (clonedJs) {
                  clonedJs.move(pos.x, pos.y);
                  clonedJs.scale(1);
                  clonedJs.opacity(1);
                  clonedJs.show();
                }
              }
            }
          });
        } else if (positions.x !== undefined && positions.y !== undefined) {
          // Old format - single position for original ornament
          const ornament = svg.querySelector('#ornament-' + i);
          if (ornament) {
            // Position using SVG.js
            const ornamentJs = SVG.adopt(ornament);
            if (ornamentJs) {
              ornamentJs.move(positions.x, positions.y);
              ornamentJs.scale(1);
              ornamentJs.opacity(1);
              ornamentJs.show();
            }
            ornament.style.visibility = 'visible';
            ornament.style.opacity = '1';
          }
        }
      }
    }
    
    // Clean up any leftover drag elements from previous sessions
    // Match both old format (ornament-X-drag) and new format (ornament-X-drag-timestamp-random)
    const leftoverDragElements = svg.querySelectorAll('[id*="-drag"]');
    leftoverDragElements.forEach(dragEl => {
      if (dragEl && dragEl.id && dragEl.id.includes('-drag')) {
        try {
          if (dragEl.parentNode) {
            dragEl.parentNode.removeChild(dragEl);
          }
        } catch (e) {
          // Cleanup error
        }
      }
    });
    
    // Wrap elements with SVG.js
    const basketJs = basket ? SVG.adopt(basket) : null;
    const treePathsJs = treePaths ? SVG.adopt(treePaths) : null;
    
    if (!basketJs || !treePathsJs) {
      return;
    }
    
    // Get all path elements within tree-paths for accurate hit detection
    const treePathElements = treePaths.querySelectorAll('path');

    let currentOrnament = null;
    let currentOrnamentIndex = 0;
    // Use saved state for placed ornaments (already restored above)
    let placedOrnaments = savedPlacedOrnaments;
    // Ensure it's a Set if it was saved as an array
    if (!(placedOrnaments instanceof Set)) {
      placedOrnaments = new Set(placedOrnaments);
    }
    // Update chapter state to use the Set
    chapterState.placedOrnaments = placedOrnaments;
    // Get ornament positions (already restored above)
    let ornamentPositions = savedOrnamentPositions;
    chapterState.ornamentPositions = ornamentPositions;
    let dragElement = null;
    let dragElementBbox = null; // Store the drag element's bbox to avoid recalculating
    let isRepositioning = false; // Track if we're moving an existing ornament
    let isPlacing = false; // Flag to prevent double placement
    let dragX = 0;
    let dragY = 0;
    let currentClickHandler = null; // Store the current click handler reference for proper removal
    let placingOrnaments = new Set(); // Track ornaments currently being placed to prevent duplicates
    let rafId = null; // RequestAnimationFrame ID for throttling drag updates
    
    // Function to setup click handler for a placed ornament
    function setupOrnamentInteract(ornament, ornamentIndex, uniqueId) {
      
      // Make it clickable and add hover effect
      ornament.style.cursor = 'pointer';
      ornament.style.pointerEvents = 'auto';
      
      // Hover effect on ornament
      ornament.addEventListener('mouseenter', function() {
        if (!dragElement) {
          gsap.to(ornament, {
            scale: 1.1,
            duration: 0.2,
            ease: 'power2.out',
            transformOrigin: 'center center'
          });
        }
      });
      
      ornament.addEventListener('mouseleave', function() {
        if (!dragElement) {
          gsap.to(ornament, {
            scale: 1,
            duration: 0.2,
            ease: 'power2.out'
          });
        }
      });
      
      // Click/touch to pick up ornament for repositioning
      const ornamentClickHandler = function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation(); // Prevent other handlers from interfering
        
        if (dragElement) {
          cancelDrag(); // Cancel existing drag first
        }
        
        // Get coordinates (works for mouse and touch)
        const coords = Mcmn.getEventCoordinates ? Mcmn.getEventCoordinates(e) : { clientX: e.clientX, clientY: e.clientY };
        
        // Hide original ornament temporarily
        gsap.set(ornament, { opacity: 0 });
        
        // Use the ornament's actual ID (could be original or cloned instance)
        const ornamentIdToUse = uniqueId || 'ornament-' + ornamentIndex;
        
        // Create drag element from the actual ornament (works for both original and cloned)
        const dragData = createDragOrnament(ornamentIdToUse, true);
        if (!dragData || !dragData.element) {
          gsap.set(ornament, { opacity: 1 });
          return;
        }
        
        dragElement = dragData.element;
        dragElementBbox = dragData.bbox; // Use the original bbox from before cloning
        
        const svgPoint = screenToSVG(coords.clientX, coords.clientY);
        
        // Calculate position to center the ornament at cursor using stored original bbox
        const centerX = svgPoint.x - (dragElementBbox.width / 2);
        const centerY = svgPoint.y - (dragElementBbox.height / 2);
        
        // Position drag element at cursor using SVG.js
        dragElement.transform({ x: 0, y: 0, scale: 1 });
        dragElement.move(centerX, centerY);
        dragElement.scale(1);
        dragElement.opacity(1);
        dragElement.show();
        
        // Set up for repositioning - store the actual ornament ID
        currentOrnament = ornamentIdToUse;
        currentOrnamentIndex = ornamentIndex;
        isRepositioning = true;
        svgContainer.style.cursor = 'none';
        
        // Remove any existing listeners first to prevent duplicates
        svgContainer.removeEventListener('mousemove', handleMouseMove);
        svgContainer.removeEventListener('touchmove', handleMouseMove);
        if (currentClickHandler) {
          svgContainer.removeEventListener('click', currentClickHandler, true);
          svgContainer.removeEventListener('click', currentClickHandler, false);
          svgContainer.removeEventListener('touchend', currentClickHandler, true);
          svgContainer.removeEventListener('touchend', currentClickHandler, false);
          currentClickHandler = null;
        }
        svgContainer.removeEventListener('click', handleClick);
        svgContainer.removeEventListener('click', handleClick, true);
        svgContainer.removeEventListener('touchend', handleClick);
        svgContainer.removeEventListener('touchend', handleClick, true);
        
        // Add event listeners - use a named function wrapper for click to ensure single execution
        svgContainer.addEventListener('mousemove', handleMouseMove);
        svgContainer.addEventListener('touchmove', handleMouseMove, { passive: false });
        
        // Create a one-time click/touch handler wrapper
        const oneTimeClickHandler = function(e) {
          // Immediately remove this listener
          svgContainer.removeEventListener('click', oneTimeClickHandler, true);
          svgContainer.removeEventListener('touchend', oneTimeClickHandler, true);
          currentClickHandler = null;
          // Call the actual handler
          handleClick(e);
        };
        
        // Store reference for cleanup
        currentClickHandler = oneTimeClickHandler;
        svgContainer.addEventListener('click', oneTimeClickHandler, true);
        svgContainer.addEventListener('touchend', oneTimeClickHandler, true);
        
        // Immediately update position
        handleMouseMove(e);
      };
      
      // Add both click and touch listeners to ornament
      
      // Test handler to see if ANY mouse events reach the element
      const testMouseHandler = function(e) {
      };
      
      ornament.addEventListener('click', ornamentClickHandler);
      ornament.addEventListener('mousedown', testMouseHandler);
      ornament.addEventListener('mouseup', testMouseHandler);
      ornament.addEventListener('touchstart', ornamentClickHandler, { passive: false });
      
      // CRITICAL FIX: Add a document-level capture listener to verify clicks are happening
      // This will tell us if the click is being blocked somewhere in the DOM tree
      const documentClickHandler = function(e) {
        if (e.target === ornament || ornament.contains(e.target)) {
        }
      };
      document.addEventListener('click', documentClickHandler, true);
    }

    // Make basket clickable and add hover effects
    if (!basket) {
      return;
    }
    
    basket.style.cursor = 'pointer';
    basket.style.pointerEvents = 'auto';
    
    // Basket hover effects
    basket.addEventListener('mouseenter', function() {
      if (!dragElement) {
        gsap.to(basket, {
          scale: 1.1,
          duration: 0.3,
          ease: 'power2.out',
          transformOrigin: 'center center'
        });
        // Add subtle glow effect
        gsap.to(basket, {
          filter: 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.5))',
          duration: 0.3
        });
      }
    });
    
    basket.addEventListener('mouseleave', function() {
      if (!dragElement) {
        gsap.to(basket, {
          scale: 1,
          duration: 0.3,
          ease: 'power2.out'
        });
        gsap.to(basket, {
          filter: 'drop-shadow(0 0 0px rgba(255, 255, 255, 0))',
          duration: 0.3
        });
      }
    });
    
    // Get all available ornaments (1-9) - now allows all ornaments, not just unplaced
    function getAvailableOrnaments(excludeIndex = null) {
      const available = [];
      for (let i = 1; i <= 9; i++) {
        // Exclude the current ornament if switching
        if (excludeIndex !== null && i === excludeIndex) {
          continue;
        }
        available.push(i); // Allow all ornaments, including already placed ones
      }
      return available;
    }

    // Randomly select any ornament (allows duplicates, but can exclude a specific index)
    function getRandomOrnament(excludeIndex = null) {
      const available = getAvailableOrnaments(excludeIndex);
      
      // Safety check: if somehow available is empty (shouldn't happen with 9 ornaments),
      // fall back to selecting from all ornaments
      if (available.length === 0) {
        return Math.floor(Math.random() * 9) + 1;
      }
      
      const randomIndex = Math.floor(Math.random() * available.length);
      const selected = available[randomIndex];
      
      // Double-check we got a valid ornament
      if (!selected || selected < 1 || selected > 9) {
        return Math.floor(Math.random() * 9) + 1;
      }
      
      return selected;
    }


    // Cache for SVG coordinate calculations (performance optimization for mobile)
    let cachedSvgRect = null;
    let cachedCTM = null;
    let cachedViewBox = null;
    let cacheTimestamp = 0;
    const CACHE_DURATION = 100; // Cache for 100ms
    
    // Function to convert screen coordinates to SVG coordinates (optimized with caching)
    function screenToSVG(x, y) {
      const now = performance.now();
      
      // Recalculate cache if stale or missing
      if (!cachedSvgRect || !cachedCTM || (now - cacheTimestamp) > CACHE_DURATION) {
        cachedSvgRect = svg.getBoundingClientRect();
        cachedCTM = svg.getScreenCTM();
        cachedViewBox = svg.viewBox.baseVal;
        cacheTimestamp = now;
      }
      
      const svgPoint = svg.createSVGPoint();
      svgPoint.x = x;
      svgPoint.y = y;
      
      // Transform to SVG coordinate system
      if (cachedCTM) {
        const inverseCTM = cachedCTM.inverse();
        const transformedPoint = svgPoint.matrixTransform(inverseCTM);
        return { x: transformedPoint.x, y: transformedPoint.y };
      }
      
      // Fallback: simple calculation
      const scaleX = cachedViewBox.width / cachedSvgRect.width;
      const scaleY = cachedViewBox.height / cachedSvgRect.height;
      
      return {
        x: (x - cachedSvgRect.left) * scaleX,
        y: (y - cachedSvgRect.top) * scaleY
      };
    }
    
    // Load and show hotspot icon over grass on hover
    // Note: These functions reference variables that aren't defined in this scope (grassHotspots, hotspotIconPath)
    // They appear to be dead code left over from chapter 4, but preserved for completeness
    function loadHotspotIconForGrass(grass, index) {
      // This function would need grassHotspots and hotspotIconPath to work
      // Currently not used in chapter 1
      return null;
    }
    
    // Show hotspot icon
    function showHotspotIcon(index) {
      // This function would need grassHotspots to work
      // Currently not used in chapter 1
    }
    
    
    // Hide hotspot icon
    function hideHotspotIcon(index) {
      // This function would need grassHotspots to work
      // Currently not used in chapter 1
    }
    
    // Function to place ornament at a specific position using SVG.js
    function placeOrnamentAtPosition(screenX, screenY, ornamentId, ornamentIndex, isRepositioningFlag) {
      // Note: isPlacing flag should already be set to true by handleClick before calling this
      // and event listeners should already be removed
      // Use passed parameters instead of global variables to prevent race conditions
      
      if (!ornamentId || !ornamentIndex) {
        isPlacing = false; // Reset flag if no ornament
        return;
      }
      
      // CRITICAL: Double-check boundary BEFORE placing - prevent any bypasses
      if (!isRepositioningFlag) {
        // For new placements, ALWAYS check boundary
        const isOver = isOverTree(screenX, screenY);
        if (!isOver) {
          isPlacing = false;
          // Immediately remove drag element - don't animate, just remove
          if (dragElement && dragElement.node && dragElement.node.parentNode) {
            dragElement.remove();
            dragElement = null;
          }
          cancelDrag();
          return;
        }
      } else {
        // For repositioning, also check boundary
        const isOver = isOverTree(screenX, screenY);
        if (!isOver) {
          isPlacing = false;
          // Immediately remove drag element - don't animate, just remove
          if (dragElement && dragElement.node && dragElement.node.parentNode) {
            dragElement.remove();
            dragElement = null;
          }
          cancelDrag();
          return;
        }
      }
      
      // CRITICAL: Check if this specific placement is already in progress (using Set for thread-safe check)
      // Use a unique key that includes timestamp to allow multiple instances
      const placementKey = ornamentIndex + '-' + Date.now();
      if (placingOrnaments.has(placementKey)) {
        return;
      }
      
      // Allow multiple instances of the same ornament type - removed restriction
      
      // Mark this placement as in progress IMMEDIATELY
      placingOrnaments.add(placementKey);
      
      // Set flag immediately to prevent any other calls
      isPlacing = true;
      currentOrnament = ornamentId; // Set this to track which ornament we're placing
      
      const svgPoint = screenToSVG(screenX, screenY);
      const ornament = svg.querySelector('#' + ornamentId);
      if (!ornament) {
        isPlacing = false;
        currentOrnament = null;
        placingOrnaments.delete(placementKey); // Remove from placing set
        cancelDrag();
        return;
      }
      
      // Wrap with SVG.js
      const ornamentJs = SVG.adopt(ornament);
      if (!ornamentJs) {
        isPlacing = false;
        currentOrnament = null;
        placingOrnaments.delete(placementKey); // Remove from placing set
        cancelDrag();
        return;
      }
      
      
      // FINAL VALIDATION: Double-check the drop point is within tree-paths before calculating position
      const finalCheck = isOverTree(screenX, screenY);
      if (!finalCheck) {
        isPlacing = false;
        currentOrnament = null;
        placingOrnaments.delete(placementKey);
        // Immediately remove drag element - don't animate, just remove
        if (dragElement && dragElement.node && dragElement.node.parentNode) {
          dragElement.remove();
          dragElement = null;
        }
        cancelDrag();
        return;
      }
      
      // Reset any existing transforms to get original position and size
      ornamentJs.transform({ x: 0, y: 0, scale: 1 });
      
      // Get bounding box of the ornament in its original position (at scale 1)
      const bbox = ornamentJs.bbox();
      
      // Calculate the position to center the ornament on the drop point
      // Use move() which positions the top-left, so we need to account for the bbox
      const dropX = svgPoint.x - (bbox.width / 2);
      const dropY = svgPoint.y - (bbox.height / 2);
      
      // Validate the calculated drop position center is still within tree-paths
      // The center check was already done above, but verify once more after coordinate calculation
      const centerCheck = isOverTree(screenX, screenY);
      if (!centerCheck) {
        isPlacing = false;
        currentOrnament = null;
        placingOrnaments.delete(placementKey);
        // Immediately remove drag element - don't animate, just remove
        if (dragElement && dragElement.node && dragElement.node.parentNode) {
          dragElement.remove();
          dragElement = null;
        }
        cancelDrag();
        return;
      }

      if (isRepositioningFlag) {
        // Repositioning existing ornament - use SVG.js move() and animate, ensure scale is 1
        ornamentJs.move(dropX, dropY);
        ornamentJs.scale(1);
        ornamentJs.show(); // Ensure it's visible
        ornamentJs.opacity(1); // Set opacity immediately instead of animating
        
        // Also ensure the element style is set correctly
        ornament.style.visibility = 'visible';
        ornament.style.opacity = '1';
        
        // Update saved position - check if this is a cloned instance or original
        const isClonedInstance = ornamentId.includes('-instance-');
        if (isClonedInstance) {
          // Cloned instance - find and update by unique ID
          if (!ornamentPositions[ornamentIndex]) {
            ornamentPositions[ornamentIndex] = {};
          }
          // The instance key should match the ornamentId exactly
          ornamentPositions[ornamentIndex][ornamentId] = {
            x: dropX,
            y: dropY
          };
        } else {
          // Original ornament - update directly
          if (!ornamentPositions[ornamentIndex]) {
            ornamentPositions[ornamentIndex] = {};
          }
          ornamentPositions[ornamentIndex][ornamentId] = {
            x: dropX,
            y: dropY
          };
        }
      } else {
        // Placing new ornament instance - CLONE the ornament so we can have multiple instances
        const clonedOrnament = ornament.cloneNode(true);
        const uniqueId = ornamentId + '-instance-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
        clonedOrnament.id = uniqueId;
        clonedOrnament.style.visibility = 'visible';
        
        // Add cloned ornament to SVG
        svg.appendChild(clonedOrnament);
        
        // Wrap cloned ornament with SVG.js
        const clonedOrnamentJs = SVG.adopt(clonedOrnament);
        if (!clonedOrnamentJs) {
          isPlacing = false;
          currentOrnament = null;
          placingOrnaments.delete(placementKey);
          cancelDrag();
          return;
        }
        
        // Set initial position using SVG.js (this ensures correct size)
        clonedOrnamentJs.move(dropX, dropY);
        clonedOrnamentJs.scale(1);
        clonedOrnamentJs.opacity(0);
        
        // Use GSAP for bounce animation
        gsap.fromTo(clonedOrnament, 
          { opacity: 0 },
          { 
            opacity: 1,
            duration: 0.3,
            ease: 'power2.out',
            onComplete: function() {
              // Ensure final state using SVG.js
              clonedOrnamentJs.move(dropX, dropY);
              clonedOrnamentJs.scale(1);
              clonedOrnamentJs.opacity(1);
            }
          }
        );
        
        // Add a subtle scale bounce using SVG.js
        clonedOrnamentJs.animate(300).scale(1.1).after(function() {
          clonedOrnamentJs.animate(200).scale(1);
        });

        // Track this instance (allow multiple instances of same type)
        placedOrnaments.add(ornamentIndex); // Still track that this type has been placed
        const instanceKey = uniqueId;
        
        // Save position with unique instance key
        if (!ornamentPositions[ornamentIndex]) {
          ornamentPositions[ornamentIndex] = {};
        }
        ornamentPositions[ornamentIndex][instanceKey] = {
          x: dropX,
          y: dropY
        };
        
        // Mark ornament grab as complete when first ornament is placed
        if (placedOrnaments.size === 1 && Mcmn.CookieManager && Mcmn.CookieManager.markHotspotComplete) {
          Mcmn.CookieManager.markHotspotComplete(sectionType, 'ornament-grab');
          // Check completion after marking hotspot
          if (Mcmn.checkCompletion) {
            const viewedSections = new Set(Mcmn.CookieManager.getViewedSections());
            Mcmn.checkCompletion(viewedSections);
          }
        }
        
        // Make the cloned ornament clickable for repositioning
        setupOrnamentInteract(clonedOrnament, ornamentIndex, uniqueId);
      }
      
      // Save state
      chapterState.placedOrnaments = placedOrnaments;
      chapterState.ornamentPositions = ornamentPositions;
      if (Mcmn.saveChapterState) {
        Mcmn.saveChapterState(sectionType, chapterState);
      }
      
      // IMMEDIATELY remove drag element after successful placement - don't animate, just remove
      if (dragElement) {
        if (dragElement.node && dragElement.node.parentNode) {
          dragElement.remove();
        }
        dragElement = null;
      }
      
      // Also check for any leftover drag elements and remove them (cleanup)
      // Match both old format (ornament-X-drag) and new format (ornament-X-drag-timestamp-random)
      const leftoverDragElements = svg.querySelectorAll('[id*="-drag"]');
      leftoverDragElements.forEach(dragEl => {
        if (dragEl && dragEl.id && dragEl.id.includes('-drag') && dragEl.parentNode) {
          try {
            dragEl.parentNode.removeChild(dragEl);
          } catch (e) {
            // Error removing drag element
          }
        }
      });
      
      // Event listeners already removed above to prevent duplicate clicks
      
      dragElementBbox = null;
      // Clear global state
      currentOrnament = null;
      currentOrnamentIndex = 0;
      isRepositioning = false;
      isPlacing = false; // Reset placement flag
      currentClickHandler = null; // Clear click handler reference
      // Remove from placing set AFTER everything is done
      placingOrnaments.delete(placementKey);
      svgContainer.style.cursor = 'crosshair';
      
      // Re-enable interact for this ornament (use passed parameters)
      // Note: For cloned instances, setupOrnamentInteract was already called during placement
      if (ornamentId && ornamentIndex && !ornamentId.includes('-instance-')) {
        // Only set up interact for original ornaments that were placed
        const ornamentElement = svg.querySelector('#' + ornamentId);
        if (ornamentElement && placedOrnaments.has(ornamentIndex)) {
          setupOrnamentInteract(ornamentElement, ornamentIndex);
        }
      }
    }

    // Function to create a dragging ornament element using SVG.js
    function createDragOrnament(ornamentId, useCurrentPosition = false) {
      const originalOrnament = svg.querySelector('#' + ornamentId);
      if (!originalOrnament) return null;

      // Get the original ornament's bbox BEFORE cloning (at original position, scale 1)
      const originalJs = SVG.adopt(originalOrnament);
      if (!originalJs) return null;
      
      // Temporarily reset any transforms to get true original bbox
      const originalTransform = originalOrnament.getAttribute('transform') || '';
      originalJs.transform({ x: 0, y: 0, scale: 1 });
      const originalBbox = originalJs.bbox();
      
      // Restore original transform if it existed
      if (originalTransform) {
        originalOrnament.setAttribute('transform', originalTransform);
      }

      // Clone the ornament
      const clone = originalOrnament.cloneNode(true);
      // Use unique ID with timestamp to avoid conflicts with multiple instances
      clone.id = ornamentId + '-drag-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
      clone.style.pointerEvents = 'none';
      clone.style.visibility = 'visible';
      clone.style.opacity = '1';
      
      // Remove any existing transform from clone to start fresh
      clone.removeAttribute('transform');
      
      // Add drop shadow filter for better visibility
      let defs = svg.querySelector('defs');
      if (!defs) {
        defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
        svg.insertBefore(defs, svg.firstChild);
      }
      
      // Check if filter already exists
      let dropShadowFilter = defs.querySelector('#drag-drop-shadow');
      if (!dropShadowFilter) {
        dropShadowFilter = document.createElementNS('http://www.w3.org/2000/svg', 'filter');
        dropShadowFilter.id = 'drag-drop-shadow';
        dropShadowFilter.setAttribute('x', '-50%');
        dropShadowFilter.setAttribute('y', '-50%');
        dropShadowFilter.setAttribute('width', '200%');
        dropShadowFilter.setAttribute('height', '200%');
        
        const feGaussianBlur = document.createElementNS('http://www.w3.org/2000/svg', 'feGaussianBlur');
        feGaussianBlur.setAttribute('in', 'SourceAlpha');
        feGaussianBlur.setAttribute('stdDeviation', '4');
        
        const feOffset = document.createElementNS('http://www.w3.org/2000/svg', 'feOffset');
        feOffset.setAttribute('dx', '0');
        feOffset.setAttribute('dy', '2');
        feOffset.setAttribute('result', 'offsetblur');
        
        const feFlood = document.createElementNS('http://www.w3.org/2000/svg', 'feFlood');
        feFlood.setAttribute('flood-color', 'rgba(0, 0, 0, 0.5)');
        
        const feComposite = document.createElementNS('http://www.w3.org/2000/svg', 'feComposite');
        feComposite.setAttribute('in2', 'offsetblur');
        feComposite.setAttribute('operator', 'in');
        
        const feMerge = document.createElementNS('http://www.w3.org/2000/svg', 'feMerge');
        const feMergeNode1 = document.createElementNS('http://www.w3.org/2000/svg', 'feMergeNode');
        const feMergeNode2 = document.createElementNS('http://www.w3.org/2000/svg', 'feMergeNode');
        feMergeNode2.setAttribute('in', 'SourceGraphic');
        
        feMerge.appendChild(feMergeNode1);
        feMerge.appendChild(feMergeNode2);
        
        dropShadowFilter.appendChild(feGaussianBlur);
        dropShadowFilter.appendChild(feOffset);
        dropShadowFilter.appendChild(feFlood);
        dropShadowFilter.appendChild(feComposite);
        dropShadowFilter.appendChild(feMerge);
        defs.appendChild(dropShadowFilter);
      }
      
      // Apply filter to clone
      clone.setAttribute('filter', 'url(#drag-drop-shadow)');
      
      // Add to SVG at the end to ensure it's on top
      svg.appendChild(clone);
      
      // Wrap with SVG.js
      const cloneJs = SVG.adopt(clone);
      if (!cloneJs) return null;
      
      // Ensure it's on top by moving to end of SVG children
      if (cloneJs.node && cloneJs.node.parentNode) {
        cloneJs.node.parentNode.appendChild(cloneJs.node);
      }
      
      // Reset all transforms to ensure clean state
      cloneJs.transform({ x: 0, y: 0, scale: 1 });
      
      // If repositioning, copy current transform
      if (useCurrentPosition && originalTransform) {
        // Parse and apply the original transform
        const originalJs = SVG.adopt(originalOrnament);
        if (originalJs) {
          const bbox = originalJs.bbox();
          cloneJs.move(bbox.x, bbox.y);
        }
      }
      
      // Ensure the clone is visible at normal size
      cloneJs.opacity(1);
      cloneJs.show();
      cloneJs.scale(1); // Keep original size
      
      // Return both the cloneJs and the original bbox for accurate positioning
      return { element: cloneJs, bbox: originalBbox };
    }


    // Function to check if point is over tree using tree-paths boundary
    function isOverTree(x, y) {
      if (!treePaths || treePathElements.length === 0) {
        return false;
      }
      
      const svgPoint = screenToSVG(x, y);
      
      // Create an SVG point in the SVG's coordinate system for path checking
      const point = svg.createSVGPoint();
      point.x = svgPoint.x;
      point.y = svgPoint.y;
      
      // STRICT: Check if point is inside ANY of the actual tree paths using isPointInFill
      // This is the ONLY valid drop zone - must be inside a path element within tree-paths
      // We check paths FIRST because this is the most accurate check
      let isInside = false;
      let pathsChecked = 0;
      let pathsWithFill = 0;
      
      for (let i = 0; i < treePathElements.length; i++) {
        const path = treePathElements[i];
        pathsChecked++;
        
        // Use the native SVG isPointInFill method
        // This checks if the point (in SVG coordinates) is inside the filled area of the path
        try {
          if (path.isPointInFill) {
            pathsWithFill++;
            if (path.isPointInFill(point)) {
              isInside = true;
              break;
            }
          } else {
            // If isPointInFill is not available, we cannot verify the point is inside
            // This should not happen with proper SVG paths, but log a warning
          }
        } catch (e) {
        }
      }
      
      // If not inside any path, definitely reject
      if (!isInside) {
        return false;
      }
      
      // Additional safety check: verify point is within tree-paths bounding box
      // This is a secondary check to catch any edge cases
      const treePathsBbox = treePaths.getBBox();
      const isWithinBbox = svgPoint.x >= treePathsBbox.x && 
                          svgPoint.x <= treePathsBbox.x + treePathsBbox.width &&
                          svgPoint.y >= treePathsBbox.y && 
                          svgPoint.y <= treePathsBbox.y + treePathsBbox.height;
      
      if (!isWithinBbox) {
        return false;
      }
      
      // Only return true if BOTH checks pass: inside a path AND within bbox
      return true;
    }

    // Mouse/touch move handler to follow cursor with drag element (optimized with requestAnimationFrame)
    function handleMouseMove(e) {
      if (!dragElement || !currentOrnament || !dragElementBbox) {
        return;
      }
      
      // Prevent scrolling on touch devices
      if (e.type === 'touchmove') {
        e.preventDefault();
      }
      
      // Cancel previous animation frame if pending
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
      }
      
      // Get coordinates immediately
      const coords = Mcmn.getEventCoordinates ? Mcmn.getEventCoordinates(e) : { clientX: e.clientX, clientY: e.clientY };
      
      // Schedule update for next frame (throttles to display refresh rate)
      rafId = requestAnimationFrame(function() {
        const svgPoint = screenToSVG(coords.clientX, coords.clientY);
        
        // Calculate position to center the ornament at cursor using stored original bbox
        const centerX = svgPoint.x - (dragElementBbox.width / 2);
        const centerY = svgPoint.y - (dragElementBbox.height / 2);
        
        // Only update position - properties are set once on drag start
        dragElement.move(centerX, centerY);
        
        rafId = null;
      });
    }
    
    // Click/touch end handler to place ornament or cancel
    function handleClick(e) {
      // Don't process if clicking on basket (but only for mouse events)
      // For touch events, target might still be original element
      if (e.type !== 'touchend') {
        if (e.target.closest && e.target.closest('#basket-of-ornaments')) {
          return; // Let basket handler process this
        }
      }
      
      // Stop propagation to prevent event bubbling and stop other handlers
      e.stopImmediatePropagation();
      e.stopPropagation();
      e.preventDefault();
      
      if (!dragElement || !currentOrnament) return;
      
      const coords = Mcmn.getEventCoordinates ? Mcmn.getEventCoordinates(e) : { clientX: e.clientX, clientY: e.clientY };
      
      // CRITICAL: Prevent double placement - set flag IMMEDIATELY and remove listeners
      if (isPlacing) {
        return;
      }
      
      // Set flag immediately to prevent any other clicks from processing
      isPlacing = true;
      
      // Store current ornament values before clearing (needed for placement)
      const ornamentToPlace = currentOrnament;
      const ornamentIndexToPlace = currentOrnamentIndex;
      const isRepositioningFlag = isRepositioning; // Store flag value
      
      // Remove event listeners immediately to prevent duplicate calls
      // Remove both direct handler and any one-time wrappers (mouse and touch)
      svgContainer.removeEventListener('mousemove', handleMouseMove);
      svgContainer.removeEventListener('touchmove', handleMouseMove);
      if (currentClickHandler) {
        svgContainer.removeEventListener('click', currentClickHandler, true);
        svgContainer.removeEventListener('click', currentClickHandler, false);
        svgContainer.removeEventListener('touchend', currentClickHandler, true);
        svgContainer.removeEventListener('touchend', currentClickHandler, false);
        currentClickHandler = null;
      }
      svgContainer.removeEventListener('click', handleClick);
      svgContainer.removeEventListener('click', handleClick, true);
      svgContainer.removeEventListener('touchend', handleClick);
      svgContainer.removeEventListener('touchend', handleClick, true);
      
      // STRICT: Only allow dropping on the tree
      const isOver = isOverTree(coords.clientX, coords.clientY);
      if (!isOver) {
        // Clicked outside tree - cancel drag and fully reset to normal state
        isPlacing = false; // Reset flag before canceling
        // Immediately remove drag element before canceling
        if (dragElement && dragElement.node && dragElement.node.parentNode) {
          dragElement.remove();
          dragElement = null;
        }
        cancelDrag();
        // Ensure we're back to normal state - ready to click basket again
        return;
      }
      
      // Allow multiple instances - removed restriction on already-placed ornaments
      
      // Only place if over tree - pass the stored values
      // This should only be called once per click
      placeOrnamentAtPosition(coords.clientX, coords.clientY, ornamentToPlace, ornamentIndexToPlace, isRepositioningFlag);
    }

    // Click/touch on basket to pick up a random ornament
    // Use capture phase to ensure this runs BEFORE container click handlers
    const basketClickHandler = function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation(); // Prevent other handlers from interfering
      
      // Mark decorate hotspot as complete
      if (Mcmn.CookieManager && Mcmn.CookieManager.markHotspotComplete) {
        Mcmn.CookieManager.markHotspotComplete(sectionType, 'decorate-hotspot');
        // Check completion after marking hotspot
        if (Mcmn.checkCompletion) {
          const viewedSections = new Set(Mcmn.CookieManager.getViewedSections());
          Mcmn.checkCompletion(viewedSections);
        }
      }

      // Store current index to exclude when switching
      const previousIndex = currentOrnamentIndex;

      // If already dragging, cancel and pick a new random ornament (allows switching)
      if (dragElement) {
        // Cancel existing drag synchronously - fully reset state
        cancelDrag();
        // Ensure state is fully cleared
        currentOrnamentIndex = 0; // Reset to allow exclusion logic to work
      }

      // Always pick a new ornament (will exclude previous if switching)
      // Use previousIndex for exclusion since we just reset currentOrnamentIndex
      const excludeIndex = (previousIndex !== 0 && previousIndex !== null) ? previousIndex : null;
      pickNewOrnament(e, excludeIndex);
    };
    
    // Add both click and touch listeners to basket
    basket.addEventListener('click', basketClickHandler, true); // Use capture phase
    basket.addEventListener('touchstart', basketClickHandler, { passive: false });
    
    // Make message clickable to trigger basket click (hotspot is hidden)
    if (decorateTheTree) {
      decorateTheTree.style.cursor = 'pointer';
      decorateTheTree.style.pointerEvents = 'auto';
      const decorateTheTreeHandler = function(e) {
        e.preventDefault();
        e.stopPropagation();
        // Trigger basket click handler
        basketClickHandler(e);
      };
      decorateTheTree.addEventListener('click', decorateTheTreeHandler);
      decorateTheTree.addEventListener('touchend', decorateTheTreeHandler, { passive: false });
    }
    
    // Helper function to pick up a new random ornament
    function pickNewOrnament(e, excludeIndex = null) {
      // Get coordinates (works for mouse and touch)
      const coords = Mcmn.getEventCoordinates ? Mcmn.getEventCoordinates(e) : { clientX: e.clientX, clientY: e.clientY };
      
      // Use provided excludeIndex, or calculate from current state
      if (excludeIndex === null) {
        excludeIndex = (currentOrnamentIndex !== 0 && currentOrnamentIndex !== null) ? currentOrnamentIndex : null;
      }
      
      const randomIndex = getRandomOrnament(excludeIndex);
      
      // Safety check: ensure we got a valid ornament
      if (!randomIndex || randomIndex < 1 || randomIndex > 9) {
        // Fallback: try again without exclusion
        const fallbackIndex = getRandomOrnament(null);
        if (!fallbackIndex || fallbackIndex < 1 || fallbackIndex > 9) {
          return;
        }
        // Use fallback
        currentOrnamentIndex = fallbackIndex;
        const ornamentId = 'ornament-' + fallbackIndex;
        isRepositioning = false;
        
        // Create drag element - returns { element, bbox }
        const dragData = createDragOrnament(ornamentId, false);
        if (!dragData || !dragData.element) {
          cancelDrag();
          return;
        }
        
        dragElement = dragData.element;
        dragElementBbox = dragData.bbox;
        
        // Position drag element at cursor
        const svgPoint = screenToSVG(coords.clientX, coords.clientY);
        const centerX = svgPoint.x - (dragElementBbox.width / 2);
        const centerY = svgPoint.y - (dragElementBbox.height / 2);
        
        dragElement.transform({ x: 0, y: 0, scale: 1 });
        dragElement.move(centerX, centerY);
        dragElement.scale(1);
        dragElement.opacity(1);
        dragElement.show();
        
        currentOrnament = ornamentId;
        svgContainer.style.cursor = 'none';
        
        // Remove any existing listeners
        svgContainer.removeEventListener('mousemove', handleMouseMove);
        svgContainer.removeEventListener('touchmove', handleMouseMove);
        if (currentClickHandler) {
          svgContainer.removeEventListener('click', currentClickHandler, true);
          svgContainer.removeEventListener('click', currentClickHandler, false);
          svgContainer.removeEventListener('touchend', currentClickHandler, true);
          svgContainer.removeEventListener('touchend', currentClickHandler, false);
          currentClickHandler = null;
        }
        svgContainer.removeEventListener('click', handleClick);
        svgContainer.removeEventListener('click', handleClick, true);
        svgContainer.removeEventListener('touchend', handleClick);
        svgContainer.removeEventListener('touchend', handleClick, true);
        
        // Add event listeners (mouse and touch)
        svgContainer.addEventListener('mousemove', handleMouseMove);
        svgContainer.addEventListener('touchmove', handleMouseMove, { passive: false });
        
        const oneTimeClickHandler = function(e) {
          svgContainer.removeEventListener('click', oneTimeClickHandler, true);
          svgContainer.removeEventListener('touchend', oneTimeClickHandler, true);
          currentClickHandler = null;
          handleClick(e);
        };
        
        currentClickHandler = oneTimeClickHandler;
        svgContainer.addEventListener('click', oneTimeClickHandler, true);
        svgContainer.addEventListener('touchend', oneTimeClickHandler, true);
        
        handleMouseMove(e);
        return;
      }

      currentOrnamentIndex = randomIndex;
      const ornamentId = 'ornament-' + randomIndex;
      isRepositioning = false; // This is a new ornament
      
      // Create drag element - returns { element, bbox }
      const dragData = createDragOrnament(ornamentId, false);
      if (!dragData || !dragData.element) {
        cancelDrag();
        return;
      }
      
      dragElement = dragData.element;
      dragElementBbox = dragData.bbox; // Use the original bbox from before cloning
      
      // Position drag element at cursor - instant using SVG.js
      const svgPoint = screenToSVG(coords.clientX, coords.clientY);
      
      // Calculate position to center the ornament at cursor using the stored original bbox
      const centerX = svgPoint.x - (dragElementBbox.width / 2);
      const centerY = svgPoint.y - (dragElementBbox.height / 2);
      
      // Reset transforms and position
      dragElement.transform({ x: 0, y: 0, scale: 1 });
      dragElement.move(centerX, centerY);
      dragElement.scale(1); // Keep original size
      dragElement.opacity(1);
      dragElement.show();

      // Set up for dragging
      currentOrnament = ornamentId;
      svgContainer.style.cursor = 'none'; // Hide cursor, ornament is the cursor
      
      // Remove any existing listeners first to prevent duplicates
      svgContainer.removeEventListener('mousemove', handleMouseMove);
      svgContainer.removeEventListener('touchmove', handleMouseMove);
      if (currentClickHandler) {
        svgContainer.removeEventListener('click', currentClickHandler, true);
        svgContainer.removeEventListener('click', currentClickHandler, false);
        svgContainer.removeEventListener('touchend', currentClickHandler, true);
        svgContainer.removeEventListener('touchend', currentClickHandler, false);
        currentClickHandler = null;
      }
      svgContainer.removeEventListener('click', handleClick);
      svgContainer.removeEventListener('click', handleClick, true);
      svgContainer.removeEventListener('touchend', handleClick);
      svgContainer.removeEventListener('touchend', handleClick, true);
      
      // Add event listeners - use a named function wrapper for click to ensure single execution (mouse and touch)
      svgContainer.addEventListener('mousemove', handleMouseMove);
      svgContainer.addEventListener('touchmove', handleMouseMove, { passive: false });
      
      // Create a one-time click/touch handler wrapper
      const oneTimeClickHandler = function(e) {
        // Immediately remove this listener
        svgContainer.removeEventListener('click', oneTimeClickHandler, true);
        svgContainer.removeEventListener('touchend', oneTimeClickHandler, true);
        currentClickHandler = null;
        // Call the actual handler
        handleClick(e);
      };
      
      // Store reference for cleanup
      currentClickHandler = oneTimeClickHandler;
      svgContainer.addEventListener('click', oneTimeClickHandler, true);
      svgContainer.addEventListener('touchend', oneTimeClickHandler, true);
      
      // Immediately update position
      handleMouseMove(e);
    }

    function cancelDrag() {
      // Cancel any pending animation frame
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      
      // Remove event listeners (mouse and touch)
      svgContainer.removeEventListener('mousemove', handleMouseMove);
      svgContainer.removeEventListener('touchmove', handleMouseMove);
      if (currentClickHandler) {
        svgContainer.removeEventListener('click', currentClickHandler, true);
        svgContainer.removeEventListener('click', currentClickHandler, false);
        svgContainer.removeEventListener('touchend', currentClickHandler, true);
        svgContainer.removeEventListener('touchend', currentClickHandler, false);
        currentClickHandler = null;
      }
      svgContainer.removeEventListener('click', handleClick);
      svgContainer.removeEventListener('click', handleClick, true);
      svgContainer.removeEventListener('touchend', handleClick);
      svgContainer.removeEventListener('touchend', handleClick, true);
      
      // Restore original ornament if repositioning
      if (isRepositioning && currentOrnament) {
        const ornament = svg.querySelector('#' + currentOrnament);
        if (ornament) {
          gsap.set(ornament, { opacity: 1 });
        }
      }
      
      // IMMEDIATELY remove drag element - don't animate, just remove
      if (dragElement) {
        if (dragElement.node && dragElement.node.parentNode) {
          dragElement.remove();
        }
        dragElement = null;
      }
      
      // Also check for any drag elements by ID pattern and remove them immediately (cleanup any orphans)
      // Match both old format (ornament-X-drag) and new format (ornament-X-drag-timestamp-random)
      const allDragElements = svg.querySelectorAll('[id*="-drag"]');
      allDragElements.forEach(dragEl => {
        if (dragEl && dragEl.parentNode && dragEl.id && dragEl.id.includes('-drag')) {
          try {
            dragEl.parentNode.removeChild(dragEl);
          } catch (e) {
            // Error removing drag element
          }
        }
      });
      
      // FULLY reset all state
      dragElementBbox = null;
      currentOrnament = null;
      currentOrnamentIndex = 0;
      isRepositioning = false;
      isPlacing = false; // Reset placement flag
      currentClickHandler = null; // Clear click handler reference
      // Clear any ornaments from placing set
      placingOrnaments.clear();
      // Reset cursor to normal state
      svgContainer.style.cursor = 'crosshair';
      
      // Clear coordinate cache
      cachedSvgRect = null;
      cachedCTM = null;
      cachedViewBox = null;
    }
    
    // Set up interact for already placed ornaments
    // This handles both original ornaments and cloned instances that were restored above
    for (let i = 1; i <= 9; i++) {
      if (placedOrnaments.has(i)) {
        const positions = ornamentPositions[i];
        if (positions) {
          // Check if it's new format (multiple instances) or old format (single position)
          if (typeof positions === 'object' && !positions.x) {
            // New format - multiple instances stored with instance keys
            Object.keys(positions).forEach(instanceKey => {
              // These cloned instances were created during restoration above
              const clonedInstance = svg.querySelector('#' + instanceKey);
              if (clonedInstance) {
                setupOrnamentInteract(clonedInstance, i, instanceKey);
              }
            });
          } else if (positions.x !== undefined && positions.y !== undefined) {
            // Old format - single position, set up interact for original ornament
            const ornament = svg.querySelector('#ornament-' + i);
            if (ornament && ornament.style.visibility !== 'hidden') {
              setupOrnamentInteract(ornament, i);
            }
          }
        }
      }
    }

    // FINAL: Ensure SVG container and SVG allow pointer events (after all setup is complete)
    if (svgContainer) {
      svgContainer.style.pointerEvents = 'auto';
    }
    if (svg) {
      svg.style.pointerEvents = 'auto';
    }

    // Register cleanup handler for when chapter is offloaded
    if (Mcmn.registerChapterInstance) {
      Mcmn.registerChapterInstance(sectionType, {
        cleanup: function() {
          // Stop all audio for this chapter
          if (Mcmn.stopAudioForSection) {
            Mcmn.stopAudioForSection(sectionType);
          }

          // Kill all GSAP animations on SVG and container
          gsap.killTweensOf(svg);
          gsap.killTweensOf(svgContainer);
          gsap.killTweensOf(basket);
          gsap.killTweensOf(lightSwitch);
          gsap.killTweensOf(lights);

          // Clean up all SVG content - remove children to free memory
          while (svg && svg.firstChild) {
            svg.removeChild(svg.firstChild);
          }

          // Mark SVG as unloaded AND remove it from container so it reloads on next visit
          if (svgContainer) {
            svgContainer.setAttribute('data-svg-loaded', 'false');
            // Also remove the SVG element itself so it gets reloaded fresh
            const svgElement = svgContainer.querySelector('svg');
            if (svgElement && svgElement.parentNode) {
              svgElement.parentNode.removeChild(svgElement);
            }
          }

        }
      });
    }
  }

  // Export functions to shared namespace
  Mcmn.initChapter1 = initChapter1;

})(Drupal, once);

